"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.AppContext=void 0;var t;(function(e){e.Kaspi="kaspi",e.Web="web"})(t||(exports.AppContext=t={}));
//# sourceMappingURL=AppContext.js.map
